/**
 * Which layout an inspection of the disposition shows for the TZB (HCIT-1143: the escalator TZB `condition.escalator`,
 * HCIT-979, or the elevator TZB) and for LG Smart (HCIT-1169: gateway, one sensor and the start direction of an
 * escalator, or the elevator layout).
 *
 * The device type reported by the SmartLift app decides (HCIT-912). Without one (older apps) an escalator TZB is shown
 * only if the app captured it; the prefill of an escalator unit alone is not enough.
 *
 * Pure function without store or REST access, so it can be tested without a component.
 */
export default {
    isEscalator (inspection) {
        if (!inspection) {
            return false;
        }

        if (inspection.deviceType === "ESCALATOR") {
            return true;
        }

        if (inspection.deviceType) {
            return false;
        }

        const condition = inspection.condition;
        return !!(condition && condition.escalator && condition.escalator.captured);
    },
};
